import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { LoaderService } from 'src/app/common/loader/loader.service';
import { Data2Service } from 'src/app/common/data2.service';

@Component({
	selector: 'app-tourism-events-documents',
	templateUrl: './tourism-events-documents.component.html',
	styleUrls: ['./tourism-events-documents.component.css'],
})
export class TourismEventsDocumentsComponent implements OnInit {
	private itemsBeforeDataLoad = 3;
	driversSenior = '';
	driversAdditional = '';
	eventId = '';
	documentType = '';
	event;
	drivers: Array<any> = [];
	vehicles: Array<any> = [];
	touristGuides: Array<any> = [];

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.eventId = this.route.snapshot.params['id'];
		this.documentType = this.route.snapshot.params['type'];
		this.api.get('/drivers/', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/touristGuides/', (result, error) => {
			this.touristGuides = result.data;
			this.loadData();
		});
	}

	print() {
		window.print();
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/tourismEvents/' + this.eventId + '/', (result, error) => {
			result.data.mappedVehicles = this.vehicles.filter((vehicle) =>
				result.data.vehicles.map((v) => v.vehicle_id).includes(vehicle.id),
			);
			this.event = result.data;
			this.event.drivers_senior = this.convertElements(this.drivers, this.event.drivers_senior, 'drivers');
			this.event.drivers_departure = this.convertElements(this.drivers, this.event.drivers_departure, 'drivers');
			this.event.drivers_program = this.convertElements(this.drivers, this.event.drivers_program, 'drivers');
			this.event.drivers_return = this.convertElements(this.drivers, this.event.drivers_return, 'drivers');
			this.event.tourist_guides_departure = this.convertElements(
				this.touristGuides,
				this.event.tourist_guides_departure,
				'touristGuides',
			);
			this.event.tourist_guides_program = this.convertElements(
				this.touristGuides,
				this.event.tourist_guides_program,
				'touristGuides',
			);
			this.event.tourist_guides_return = this.convertElements(
				this.touristGuides,
				this.event.tourist_guides_return,
				'touristGuides',
			);
			this.loader.hide();
		});
	}

	private convertCrews(crews: Array<any>): string {
		const result: Array<any> = [];
		crews.forEach((crew) => {
			result.push(this.convertElements(this.drivers, crew, 'drivers'));
		});
		return result.join(', ');
	}

	private convertElements(objects: Array<any>, elements: Array<any>, type: string): string {
		const result: Array<any> = [];
		elements.forEach((element) => {
			let elementData = '';
			switch (type) {
				case 'drivers':
					const driver = objects.find((obj) => obj.id == element.driver);
					elementData = driver?.last_name + ' ' + driver?.first_name + ' (';
					elementData += driver.phone_business ? driver.phone_business : '';
					if (driver.phone_private) {
						if (driver.phone_business) {
							elementData += ', ';
						}
						elementData += driver.phone_private;
					}
					elementData += ')';
					break;
				case 'touristGuides':
					const elementObj = objects.find((obj) => obj.id == element);
					elementData = elementObj?.lastName + ' ' + elementObj?.firstName + ' (';
					elementData += elementObj.phoneBusiness ? elementObj.phoneBusiness : '';
					if (elementObj.phonePrivate) {
						if (elementObj.phoneBusiness) {
							elementData += ', ';
						}
						elementData += elementObj.phonePrivate;
					}
					elementData += ')';
					break;
			}
			result.push(elementData);
		});
		return result.join(', ');
	}
}
